import { Component, OnInit,AfterViewInit , ViewChild, ElementRef } from '@angular/core';
import { UserService } from "../services/user/user.service";
import {Chart} from 'chart.js';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-balances',
  templateUrl: './balances.component.html',
  styleUrls: ['./balances.component.css']
})
export class BalancesComponent implements AfterViewInit {

  balanceData=[];
  detailsData = [];
  token:any
  @ViewChild('balance') balancesAge: ElementRef;
  constructor(private userService:UserService) {
    // this.userService.statistics().subscribe(res =>{
    //   for (let i = 1; i <= 5; i++) {
    //     this.balanceData.push(res["balance"]["g"+i]);
    //   }
    // })
    this.token = localStorage.getItem('token')
  }

  ngAfterViewInit(): void {
    this.userService.statistics().subscribe(res =>{
      for (let i = 1; i <= 5; i++) {
        this.balanceData.push(res["balance"]["facture"]["g"+i]);
      }
      var d = new Date();
      var currentMont = d.getMonth()
      d.setMonth(d.getMonth() - 1)
      var currentMontPlus1 = d.getMonth()
      var d = new Date();
      d.setMonth(d.getMonth() - 2)
      var currentMontPlus2 = d.getMonth()
      var d = new Date();
      d.setMonth(d.getMonth() - 3)
      var currentMontPlus3 = d.getMonth()
      var month = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Aout','Septembre','Octobre','Novembre','Décembre'];
      
      const labels = [
        '+90 j',
        month[currentMontPlus3],
        month[currentMontPlus2],
        month[currentMontPlus1],
        month[currentMont],
      ];

      const data = {
        labels: labels,
        datasets: [{
        label: 'Total',
        backgroundColor: '#c80217',
        borderColor: '#000',
        data: this.balanceData.reverse(),
        }]
      }
      const chart1 = new Chart(
      this.balancesAge.nativeElement,{type: "bar",data: data} );
    })

    this.userService.statistics('BAdetails').subscribe(res =>{
      this.detailsData = res['result']['RES']
    })



  }

  public openPDF(): void {
    let DATA: any = document.getElementById('facture');
    html2canvas(DATA).then((canvas) => {
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('balance.pdf');
    });
  }

}
